import { useAuth } from "context/AuthProvider";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { apiDepartamentosService } from "services/apiDepartamentosService";
import { apiexportacionService } from "services/apiExportacionService";

const ExportarFichajes = () => {
  const { empresa } = useAuth();
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  
  const [departamentos, setDepartamentos] =useState([]);
  const [departamentoId, setDepartamentoId] =useState("");
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    await apiexportacionService.getFichajesByDate(
      empresa.id,
      startDate ,
      endDate,
      departamentoId
    );
  };

  useEffect(() => {
    const fetchData = async () =>{
      const response = await apiDepartamentosService.getAll(empresa.id,0,1000);
      setDepartamentos(response.content)
    }
    fetchData();
  }, [empresa])
  


  return (
    <>
      <Card className="shadow">
        <Form>
          <CardHeader className="bg-transparent">Informe de fichajes simplificado</CardHeader>
          <CardBody>
            <FormGroup>
              <Row>
                <Col>
                  <Label>Fecha desde:</Label>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  >
                    {" "}
                  </Input>
                </Col>
                <Col>
                  <Label>Fecha hasta:</Label>
                  <Input
                    type="date"
                    id="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  >
                    {" "}
                  </Input>
                </Col>
              </Row>
            </FormGroup>
            <FormGroup row>
                            <Col>
                            <Label  for='departameto'>departameto:</Label>
                        
                                <Input type="select" name="select" id="departameto" value={departamentoId} onChange={(e) => setDepartamentoId(e.target.value)}>
                                    <option value={""}>Todos los departamentos</option>
                                    {departamentos.map((departamento, index)=> (
                                        <option key={index} value={departamento.id}>{departamento.nombre}</option>
                                    ))}
                                </Input>
                                </Col>
                        </FormGroup>
          </CardBody>
          <CardFooter className="text-center">
            <Button
              className="btn btn-success"
              onClick={(e) => handleSubmit(e)}
            >
              Descargar
            </Button>
          </CardFooter>
        </Form>
      </Card>
    </>
  );
};

export default ExportarFichajes;
